import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { brandApi } from "../../../assets/apis";
import toast from "react-hot-toast";
import Spinner from "../../../spinner/first_spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  setSiderBarActiveLink,
  setSiderBarActiveList,
} from "../../../redux-store/sidebarActiveList";
import CoverSpin from "../../../spinner/second_spinner/CoverSpin";
import SecondSpinner from "../../../spinner/third_spinner/SecondSpinner";
import NotFoundWithImage from "../../../notFound/NotFoundWithImage/NotFoundWithImage";

const EditBrand = () => {
  const { FYear } = useSelector((store) => store.FinancialYear);
  const dispatch = useDispatch();
  const [editedBrandData, setEditedBrandData] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, isError, isLoading, error, isFetching } = useQuery({
    queryKey: [id, FYear.value],
    queryFn: () =>
      axios.get(`${brandApi}/${id}`).then((response) => response.data.data),
    retry: false,
  });

  useEffect(() => {
    if (data) {
      const { createdAt, updatedAt, companyId, id, ...rest } = data;
      setEditedBrandData(rest);
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditedBrandData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleInputChangeWithCondition = (e, validationRegex) => {
    const { name, value } = e.target;
    if (value === "" || validationRegex.test(value)) {
      setEditedBrandData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) => {
      return axios.put(`${brandApi}/${id}`, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["brand"]);
      toast.success("Brand saved successfully!");
      navigate("/brand");
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message;
      toast.error(` ${errorMessage}`);
    },
  });

  const handleSaveBrand = (e) => {
    e.preventDefault();

    const { name, description } = editedBrandData;
    let updatedBrandData = {
      ...editedBrandData,
      name: name.trim(),
      ...(description && { description: description.trim() }),
    };
    setEditedBrandData(updatedBrandData);
    if (!updatedBrandData.name) return toast.error("Please enter brand name");
    mutation.mutate(updatedBrandData);
  };

  useEffect(() => {
    dispatch(setSiderBarActiveList({ name: "Items" }));
    dispatch(setSiderBarActiveLink({ link: "brand" }));
  }, []);

  if (isLoading || isFetching) {
    return (
      <div className="main-panel">
        <div className="content-wrapper">
          <SecondSpinner />
        </div>
      </div>
    );
  }

  if (isError) return <NotFoundWithImage />;
  return (
    <div className={`main-panel`}>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between m-1 p-1 align-items-baseline ">
              <h3 className="ukhd mb-3">Edit Brand</h3>
              <button
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => navigate("/brand")}
              >
                <div className="d-flex justify-content-center">
                  <i className="mdi mdi mdi-keyboard-backspace"></i>
                  <span>Back</span>
                </div>
              </button>
            </div>
            <div className="row flex-grow">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card card-rounded">
                  <div className="card-body">
                    <div className="col-lg-12">
                      <div className="col-lg-12 ">
                        <h5>BRAND INFORMATION</h5>
                      </div>
                      <form onSubmit={handleSaveBrand}>
                        <div className="col-lg-4 mt-4">
                          <label>Name</label>
                          <input
                            type="text"
                            name="name"
                            required
                            className="form-control"
                            placeholder="Brand"
                            value={editedBrandData.name || ""}
                            onChange={(e) =>
                              handleInputChangeWithCondition(e, /^[\s\S]*$/)
                            }
                          />
                        </div>
                        <div className="col-lg-6 mt-4">
                          <label>Active ? </label>{" "}
                          <input
                            type="checkbox"
                            name="active"
                            checked={editedBrandData.active || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-9 mt-4">
                          <label
                            className="form-control-label"
                            htmlFor="input-address"
                          >
                            Description
                          </label>
                          <textarea
                            className="form-control form-control-alternative"
                            rows="7"
                            style={{
                              borderRadius: "5px",
                              resize: "none",
                              minHeight: "80px",
                            }}
                            name="description"
                            value={editedBrandData.description || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-9 mt-2">
                          <button
                            type="submit"
                            className="btn btn-primary d-flex justify-content-center px-3 py-2"
                          >
                            <i className="mdi mdi-content-save me-1"></i> Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBrand;
